import { NoBlending, ShaderMaterial, Uniform } from 'three'

import fragmentShader from "./glsl/LensDistortion.frag";
import vertexShader from "./glsl/LensDistortion.vert";

/**
 * A simple copy shader material.
 */

export class LensDistortionMaterial extends ShaderMaterial {

    constructor() {
        super({
            name: "LensDistortionMaterial",
            defines: {
                BAND_MODE: 1, // 0: NONE, 1: RGB, 2: RYGCBV
                CHROMA_SAMPLES: 7,
            },
            uniforms: {
                inputBuffer: new Uniform(null),
                baseIor: new Uniform(1.0),
                bandOffset: new Uniform(-0.001),
                jitterIntensity: new Uniform(2.0),
                jitterOffset: new Uniform(0.0),
                opacity: new Uniform(1.0),
            },
            blending: NoBlending,
            depthWrite: false,
            depthTest: false,
            fragmentShader,
            vertexShader
        });
    }


    /**
     * The input buffer.
     *
     * @type {Texture}
     */

    set inputBuffer(value) {

        this.uniforms.inputBuffer.value = value;

    }

    /**
     * Sets the input buffer.
     *
     * @deprecated Use inputBuffer instead.
     * @param {Number} value - The buffer.
     */

    setInputBuffer(value) {

        this.uniforms.inputBuffer.value = value;

    }

    /**
     * Returns the opacity.
     *
     * @deprecated Use opacity instead.
     * @return {Number} The opacity.
     */

    getOpacity(value) {

        return this.uniforms.opacity.value;

    }

    /**
     * Sets the opacity.
     *
     * @deprecated Use opacity instead.
     * @param {Number} value - The opacity.
     */

    setOpacity(value) {

        this.uniforms.opacity.value = value;

    }

}
